// extracted by mini-css-extract-plugin
export var bodySections = "_ac-8";
export var gray = "_ac-7";
export var green = "_ac-4";
export var iconContainer = "_ac-9";
export var iconWidgetContainer = "_ac-1";
export var phoneIcon = "_ac-2";
export var red = "_ac-5";
export var statusDot = "_ac-3";
export var widgetContainer = "_ac-0";
export var yellow = "_ac-6";